import apiErrorHelper from "../../Util/apiErrorHelper";
import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getAllBuildings = createAsyncThunk(
  "buildings/getAllBuildings",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllBuildings.url,
        method: API.admin.getAllBuildings.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllLockProviders = createAsyncThunk(
  "buildings/getAllLockProviders",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllLockProviders.url,
        method: API.admin.getAllLockProviders.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const createBuilding = createAsyncThunk(
  "buildings/createBuilding",
  async (
    params: {
      buildingName: string;
      address: string;
      city: string;
      state: string;
      zip: string;
      lockProviderId: string;
      lockProviderEndpoint: string;
      image: string;
      lat: string;
      long: string;
      username: string;
      password: string;
      amenigiesShare: string;
      ownerShare: string;
      groupId: string;
      guideImage1: string;
      guideImage2: string;
      guideImage3: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.createBuilding.url,
        method: API.admin.createBuilding.method,
        data: params,
      });

      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateBuilding = createAsyncThunk(
  "buildings/updateBuilding",
  async (
    params: {
      buildingId: string;
      buildingName: string;
      address: string;
      city: string;
      state: string;
      zip: string;
      lockProviderId: string;
      lockProviderEndpoint: string;
      image: string;
      lat: string;
      long: string;
      username: string;
      password: string;
      amenigiesShare: string;
      ownerShare: string;
      groupId: string;
      guideImage1: string;
      guideImage2: string;
      guideImage3: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateBuilding.url,
        method: API.admin.updateBuilding.method,
        data: params,
      });

      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getMembersByBuildingId = createAsyncThunk(
  "buildings/getMembersByBuildingId",
  async (params: { buildingId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getMembersByBuildingId.url + `/${params.buildingId}`,
        method: API.admin.getMembersByBuildingId.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getBuildingByBuildingId = createAsyncThunk(
  "buildings/getBuildingByBuildingId",
  async (params: { buildingId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getBuildingById.url + params.buildingId,
        method: API.admin.getBuildingById.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(apiErrorHelper(error)));
    }
  },
);

export const uploadMembersByBuildingId = createAsyncThunk(
  "buildings/uploadMembersByBuildingId",
  async (params: { buildingId: string; file: File; apiModalDataHandler: (data: any) => void }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", params.file);
      formData.append("buildingId", params.buildingId);
      const { data } = await axios({
        url: API.admin.uploadMembers.url,
        method: API.admin.uploadMembers.method,
        data: formData,
      });

      toastHelper.success(data?.message);
      params.apiModalDataHandler(data);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const uploadExistingMembersByBuildingId = createAsyncThunk(
  "buildings/uploadExistingMembersByBuildingId",
    async (params: { buildingId: string; file: File; apiModalDataHandler: (data: any) => void }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", params.file);
      formData.append("buildingId", params.buildingId);
      const { data } = await axios({
        url: API.admin.uploadExistingMembers.url,
        method: API.admin.uploadExistingMembers.method,
        data: formData,
      });

      toastHelper.success(data?.message);
      params.apiModalDataHandler(data);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getBuildingsByGroupId = createAsyncThunk(
  "buildings/getBuildingsByGroupId",
  async (params: { groupId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getBuildingsByGroupId.url + params.groupId,
        method: API.admin.getBuildingsByGroupId.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteBuilding = createAsyncThunk(
  "buildings/deleteBuilding",
  async (
    params: {
      id: number;
      successHandler: () => void;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteBuilding.url + params?.id,
        method: API.admin.deleteBuilding.method,
      });

      dispatch(params.successHandler);

      dispatch(getAllBuildings());

      toastHelper.success(data?.message);

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetBuildingByBuildingId = createAsyncThunk(
  "buildings/clearGetBuildingByBuildingId",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetAmenitiesByBuildingId = createAsyncThunk(
  "buildings/clearGetAmenitiesByBuildingId",
  async (_, { rejectWithValue }) => {
    return null;
  },
);

export const clearGetPackagesByBuildingId = createAsyncThunk(
  "buildings/clearGetPackagesByBuildingId",
  async (_, { rejectWithValue }) => {
    return null;
  },
);
